import { useCallback, useEffect, useState } from "react";

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

export default function useRecog() {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [stream, setStream] = useState(null);

  const recognition = window.speechRecog || (window.speechRecog = new SpeechRecognition());

  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.lang = "en-US";

  const startListening = async () => {
    try {
      setStream(await navigator.mediaDevices.getUserMedia({ audio: true }));
      setIsListening(true);
      recognition.start();
    } catch (error) {
      console.log(error);
      alert("Microphone permission denied.");
    }
  };

  const stopListening = () => {
    if (stream) {
    }
    setIsListening(false);
    setTranscript("");
    recognition.stop();
  };

  useEffect(() => {
    if (!isListening && stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  }, [stream, isListening]);

  recognition.onresult = (event) => {
    const currentTranscript = Array.from(event.results)
      .map((result) => result[0])
      .map((result) => result.transcript)
      .join("");

    setTranscript(currentTranscript);
  };

  recognition.onerror = (event) => {
    console.error(event.error);
    setIsListening(false);
  };

  return { recognition, isListening, transcript, startListening, stopListening };
}
